import { gql } from '@apollo/client';

export const UPDATE_CONTACT = gql`
  mutation updateUserAsAdmin(
    $userId: Int!
    $firstname: String
    $lastname: String
    $communityName: String
    $email: String
    $phoneNumber: String
    $phoneNumberCountryCode: ECountries
  ) {
    user {
      updateUserAsAdmin(
        userId: $userId
        firstname: $firstname
        lastname: $lastname
        communityName: $communityName
        email: $email
        phoneNumber: $phoneNumber
        phoneNumberCountryCode: $phoneNumberCountryCode
      )
    }
  }
`;
